import React from "react";
import styled from "styled-components";
import { useTranslation } from "@lib/i18n";
import { string } from "prop-types";

import Layout from "@components/Layout/Layout";
import Heading from "@components/shared/Heading";
import Typography from "@components/shared/Typography";
import { color, desktop } from "@components/shared/utils";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${color("white")};
  border-top: 7rem solid ${color("black1")};
  padding: 4rem 2rem;

  ${desktop`
    flex-direction: row;
    padding: 5rem;
  `}
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  justify-content: center;

  ${desktop`
    justify-content: flex-start;
    padding: 2rem;
  `}
`;

const StyledHeading = styled(Heading)`
  text-align: center;
  padding-bottom: 2rem;
`;

const StyledImg = styled.img`
  width: 20rem;

  ${desktop`
    width: auto;
  `}
`;

const ErrorPage = ({ title, description }) => {
  const { t } = useTranslation();

  return (
    <Layout>
      <Container>
        <Content>
          <StyledHeading>{title ?? t("errors.default")}</StyledHeading>
          {description && <Typography>{description}</Typography>}
        </Content>
        <StyledImg
          src={getStaticAssetURL("/images/preconfigs/front-default.png")}
        />
      </Container>
    </Layout>
  );
};

ErrorPage.propTypes = {
  title: string,
  description: string,
};

export default ErrorPage;
